import { render } from "./SearchPage.vue?vue&type=template&id=7f4ff188&scoped=true"
import script from "./SearchPage.vue?vue&type=script&lang=js"
export * from "./SearchPage.vue?vue&type=script&lang=js"

import "./SearchPage.vue?vue&type=style&index=0&id=7f4ff188&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f4ff188"]])

export default __exports__